import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { MapData, MapDataAddress } from '@/types/map-data';
import normalizeAddress from '@/api/normalizeAddress';

@Component({
    filters: {
        fullAddress: normalizeAddress
    }
})
export class ContactListElementAbstract extends Vue {
    @Prop({default: null}) mapData!: MapData
    @Emit() selectMarker() {
        [].forEach.call((this.$el.parentElement as HTMLElement).querySelectorAll('tr'), function(el: HTMLElement) {
            el.classList.remove('primary')
            el.classList.remove('white--text')
        })
        this.$el.classList.add('primary')
        this.$el.classList.add('white--text')
        return this.mapData
    }
}